const buildSelectOptions = (entry) => {
  const items = Array.isArray(entry?.dati) ? entry.dati : [];
  return items
    .filter((item) => item && item.idPS)
    .map((item) => ({
      value: String(item.idPS),
      label: item.desc ?? String(item.idPS),
    }));
};

const buildConfigItem = (key, label, entry) => ({
  key,
  label,
  type: "select",
  options: buildSelectOptions(entry),
});

export const buildMongoArticoliFiltersConfig = (datiUlterioriStandard = {}) => {
  const generici = datiUlterioriStandard?.generici ?? {};
  const web = datiUlterioriStandard?.web ?? {};

  return [
    {
      key: "categoriaPredefinita",
      label: "Categoria web predefinita",
      type: "tree",
      options: Array.isArray(datiUlterioriStandard?.categorieWeb)
        ? datiUlterioriStandard.categorieWeb
        : [],
    },
    {
      key: "categorieWeb",
      label: "Categorie web",
      type: "tree",
      options: Array.isArray(datiUlterioriStandard?.categorieWeb)
        ? datiUlterioriStandard.categorieWeb
        : [],
    },
    buildConfigItem("persona", "Persona", generici.persona),
    buildConfigItem(
      "stagioneCollezione",
      "Stagione/collezione",
      generici.stagioneCollezione
    ),
    buildConfigItem(
      "stagioneConsigliata",
      "Stagione consigliata",
      generici.stagioneConsigliata
    ),
    buildConfigItem("utilizzo", "Utilizzo", generici.utilizzo),
    buildConfigItem("attivoSuEcom", "Attivo su e-commerce", web.attivoSuEcom),
    buildConfigItem("exportAmazon", "Export su Amazon", web.exportAmazon),
    buildConfigItem("continuativo", "Continuativo", web.continuativo),
    buildConfigItem("metodoSpedizione", "Metodo spedizione", web.metodoSpedizione),
    buildConfigItem("personalizzato", "Articolo Personalizzato", web.personalizzato),
    buildConfigItem("alwaysOn", "Always on", web.alwaysOn),
  ];
};

